import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FilesService, FileItem } from 'app/shared';
import { ProjectHandler, NewProjectSettings } from 'modeler/project-handler';
import { concatMap } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ClientEditorComponent } from '../client-editor/client-editor.component';
import { ITdDynamicElementConfig } from 'app/shared/dynamic-forms/services/dynamic-forms.service';
import { compileText } from 'app/planner/print-dialog/template-compiler';
import { SystemService, OrderSettings } from 'app/shared/system.service';

@Component({
  selector: 'app-new-order',
  templateUrl: './new-order.component.html',
  styleUrls: ['./new-order.component.scss']
})
export class NewOrderComponent implements OnInit {
  constructor(
    public system: SystemService,
    private files: FilesService,
    private router: Router,
    private dialogRef: MatDialogRef<NewOrderComponent>,
  ) {
    this.files.nextFileId().subscribe(id => this.name.setValue(`Проект ${id}`));
    this.files.getProjectTemplates().subscribe(list => {
      if (list.length > 0) {
        this.templates = list;
      }
    });
  }

  ngOnInit() {
    this.system.getSettings(OrderSettings).subscribe(s => {
      this.orderParamsFormElements = s.customParams || [];
      if (s.projectName) {
        this.projectNameTemplate = s.projectName;
      }
    });
  }

  templates: FileItem[];
  projectNameTemplate?: string;
  orderParamsFormElements: ITdDynamicElementConfig[] = [];

  useTemplates = new UntypedFormControl(false);
  name = new UntypedFormControl('', [Validators.required]);

  sizeValidators = [Validators.min(1000), Validators.max(50000)];
  length = new UntypedFormControl(5000, this.sizeValidators);
  width = new UntypedFormControl(4000, this.sizeValidators);
  height = new UntypedFormControl(2500, this.sizeValidators);
  thickness = new UntypedFormControl(100, [Validators.min(1), Validators.max(500)]);
  orderParamsForm = new UntypedFormGroup({});
  roomForm = new UntypedFormGroup({
    length: this.length,
    width: this.width,
    height: this.height,
    thickness: this.thickness
  });

  creating = false;
  error: string;

  @ViewChild(ClientEditorComponent, { static: true }) clientEditor: ClientEditorComponent;

  canCreateOrder() {
    let canCreate = this.name.valid && this.orderParamsForm.valid && !this.creating && this.clientEditor.form.valid;
    return canCreate;
  }

  async getProjectName() {
    if (this.projectNameTemplate) {
      return await compileText(this.projectNameTemplate, { client: this.clientEditor.form.value });
    }
    return this.name.value;
  }

  async createFromTemplate(template: FileItem) {
    if (!this.clientEditor.form.valid || this.creating) {
      return;
    }
    this.creating = true;
    let command =  {
      type: 'load',
      undo: 'clear',
      file: template.id,
      flushModelId: template.id.toString()
    }
    this.createOrder(this.files.createProject(await this.getProjectName(), command));
  }

  async createProject() {
    if (!this.roomForm.valid || !this.clientEditor.form.valid || this.creating) {
      return;
    }
    this.creating = true;
    let name = await this.getProjectName();
    let project = this.system.getSettings(NewProjectSettings).pipe(
      concatMap(settings => {
        let command = ProjectHandler.createNewProject(settings.extend({
          length: this.length.value,
          width: this.width.value,
          height: this.height.value,
          thickness: this.thickness.value
        }));
        return this.files.createProject(name, command);
      })
    );
    this.createOrder(project);
  }

  createOrder(project: Observable<FileItem>) {
    project.pipe(
      concatMap(p => this.clientEditor.saveOrderInfo(p.id, this.orderParamsForm.value))
    ).subscribe(order => {
      this.dialogRef.close();
      this.router.navigate(['/project', order.id]);
    }, e => (this.error = e));
  }

  cancel() {
    this.dialogRef.close();
  }
}
